import { Typography, Paper, Select, FormControl } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 0.5rem 0;

  > div {
    width: 300px;

    @media (max-width: 425px) {
      width: 220px;
    }

    @media (max-width: 375px) {
      width: 150px;
    }
  }

  p {
    margin-left: 1.5rem;

    color: #3f51b5;

    font-weight: 700;
    text-transform: uppercase;

    @media (max-width: 425px) {
      white-space: nowrap;
    }
  }
`;

export const WrapperGroupText = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  @media (max-width: 425px) {
    align-items: flex-start;
    flex-direction: column;

    padding-bottom: 1rem;
  }
`;

export const WrapperInputs = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0.5rem 0;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const WrapperTitle = styled(Typography)`
  text-transform: uppercase;

  font-weight: 700;
  font-size: 1.2rem;
`;

export const WrapperGroupInput = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr) 2fr;
  grid-gap: 1.5rem;
`;

export const WrapperGrid = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  > div:not(:first-child) {
    margin-top: 1.5rem;
  }
`;

export const WrapperTabela = styled(Paper)`
  padding: 1rem;

  width: 100%;

  display: flex;
  flex-direction: column;

  .MuiTableContainer-root {
    max-height: ${(props) => props.height};

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }
  }

  input {
    padding-top: 0;
    padding-bottom: 0;

    cursor: pointer;

    background: rgba(255, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.8);

    text-align: right;

    border: 1px solid rgba(255, 0, 0, 0.2);

    font-size: 1.3rem;
  }
`;

export const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  //padding: 0.5rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

export const WrapperFormControl = styled(FormControl)``;
